<iframe #iframeRef [class]="iframeClass" [title]="title"></iframe>
